const pad2 = (n) => String(n).padStart(2, "0");

export const toApiDate = (date) => {
  if (!date || Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
};

export const parseApiDate = (value) => {
  if (!value || typeof value !== "string") return null;
  const [y, m, d] = value.split("-").map(Number);
  if (!y || !m || !d) return null;
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatRangeLabel = (from, to, { emptyLabel = "All dates" } = {}) => {
  if (!from && !to) return emptyLabel;
  const opts = { day: "numeric", month: "short", year: "numeric" };
  try {
    if (from && to) {
      const a = parseApiDate(from);
      const b = parseApiDate(to);
      if (a && b) {
        return `${a.toLocaleDateString("en-GB", opts)} – ${b.toLocaleDateString("en-GB", opts)}`;
      }
    }
    if (from) {
      const a = parseApiDate(from);
      if (a) return `From ${a.toLocaleDateString("en-GB", opts)}`;
    }
    if (to) {
      const b = parseApiDate(to);
      if (b) return `To ${b.toLocaleDateString("en-GB", opts)}`;
    }
  } catch {
    /* ignore */
  }
  if (from && to) return `${from} — ${to}`;
  if (from) return `From ${from}`;
  if (to) return `To ${to}`;
  return emptyLabel;
};

export const DATE_PARAM_KEYS = {
  fromTo: { start: "from_date", end: "to_date" },
  startEnd: { start: "start_date", end: "end_date" },
};

export const appendDateRangeParams = (params, { start = "", end = "" }, keys) => {
  if (start) params.set(keys.start, start);
  if (end) params.set(keys.end, end);
  return params;
};

export const validateDateRange = (from, to, { requireBoth = false } = {}) => {
  if (!from && !to) {
    return requireBoth
      ? { valid: false, message: "Please select From and To dates" }
      : { valid: true };
  }
  if (from && !to) return { valid: false, message: "Please select To date" };
  if (!from && to) return { valid: false, message: "Please select From date" };
  if (from > to) return { valid: false, message: "From date cannot be after To date" };
  return { valid: true };
};
